import { render, staticRenderFns } from "./SummaryAndCommission.vue?vue&type=template&id=b637c3be&scoped=true"
import script from "./SummaryAndCommission.vue?vue&type=script&lang=js"
export * from "./SummaryAndCommission.vue?vue&type=script&lang=js"
import style0 from "./SummaryAndCommission.vue?vue&type=style&index=0&id=b637c3be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b637c3be",
  null
  
)

export default component.exports